export class AANBanner {

	init(): void {
		const bannerElements: HTMLElement[] = [].slice.call(document.querySelectorAll(".banner"));

		if(!bannerElements?.length){
			return;
		}

		const closedBanners = JSON.parse(window.localStorage.closeBanner || "{}");

		bannerElements.forEach(banner => {
			const bannerId = this.bannerid(banner);
			const closeButton = banner.querySelector(".btn-close");
			if (!closedBanners[bannerId]) {
				banner.style.display = "block";
			} else {
				banner.style.display = "none";
			}

			if(closeButton) {
				closeButton.addEventListener("click", this.bannerClick);
			}
		});
	}

	private bannerid(element: HTMLElement) {
		const id = element.id || element.classList[element.classList.length - 1];

		return id;
	};

	private getBanner(element: HTMLElement | null): HTMLElement | null {
		if(!element) {
			return null;
		}

		if (element.classList.contains("banner")) {
			return element;
		} else if (element.tagName.toLowerCase() === "body") {
			return null;
		} else {
			return this.getBanner(element.parentElement);
		}
	};

	private bannerClick = (event: Event) => {
		const banner = this.getBanner(event.target as HTMLElement);

		if (!banner) {
			return;
		}

		const id: string = this.bannerid(banner);
		const closedBanners = JSON.parse(window.localStorage.closeBanner || "{}");

		closedBanners[id] = "true";
		banner.style.display = "none";

		window.localStorage.closeBanner = JSON.stringify(closedBanners);
	};
}


document.addEventListener("DOMContentLoaded", () => {
	const banner = new AANBanner();

	banner.init();
});
